export type SortDirection = 'asc' | 'desc'

export interface SortableTableHeaderProps<TKey extends string> {
  label: string
  sortKey: TKey
  activeKey: TKey | null
  direction: SortDirection
  onSort: (key: TKey) => void
  title?: string
  className?: string
}

export function SortableTableHeader<TKey extends string>({
  label,
  sortKey,
  activeKey,
  direction,
  onSort,
  title = 'Click to sort',
  className,
}: SortableTableHeaderProps<TKey>) {
  const active = sortKey === activeKey
  return (
    <th className={className} scope="col">
      <button
        type="button"
        className={[
          'inline-flex items-center gap-1 text-left font-medium transition',
          active ? 'text-slate-900' : 'text-slate-500 hover:text-slate-900',
        ].join(' ')}
        title={title}
        onClick={() => onSort(sortKey)}
        aria-sort={active ? (direction === 'asc' ? 'ascending' : 'descending') : undefined}
      >
        <span>{label}</span>
        <span className="text-[10px] text-slate-400">{active ? (direction === 'asc' ? '▲' : '▼') : '↕'}</span>
      </button>
    </th>
  )
}

export function nextSortDirection(current: SortDirection): SortDirection {
  return current === 'asc' ? 'desc' : 'asc'
}
